/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./gate.defs.js";
export { main as default } from "./gate.defs.js";
